<template>
  <div>
    <div class="container">
      <div
        class="flex lg:justify-between lg:gap-2 gap-5 lg:flex-row flex-col lg:items-end xl:mb-[70px] lg:mb-10 mb-5 px-5 md:px-7.5 lg:px-10 1.5xl:px-12.5"
      >
        <div class="flex flex-col gap-[25px]">
          <h2 class="text-primary-gray-800">Who do we cater to</h2>
          <p1 v-i18n="landingPage" class="text-primary-gray-600 md:max-w-[66%]">CATER_DESCP</p1>
        </div>
        <div
          :key="forceRender"
          class="flex flex-row lg:items-end items-center justify-end xl:gap-[30px] md:gap-4 gap-2"
        >
          <div class="flex sm:gap-[15px] gap-2">
            <div
              class="cursor-pointer lg:h-14 sm:h-12 h-11 lg:w-14 sm:w-12 w-11 flex justify-center items-center bg-white border-2 rounded-full"
              :class="iconLeftBorder"
              @click="prevSlide"
            >
              <Icon icon="arrowLeft" :color="iconLeftColor" />
            </div>
            <div
              class="cursor-pointer lg:h-14 sm:h-12 h-11 lg:w-14 sm:w-12 w-11 flex justify-center items-center bg-white border-2 rounded-full"
              :class="iconRightBorder"
              @click="nextSlide"
            >
              <Icon icon="arrow" :color="iconRightColor" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="px-10 xm:px-0 xm:pl-10 md:pl-15 lg:pl-20 1.5xl:pl-25 max-w-[1440px] 2xl:max-w-[1536px] mx-auto"
    >
      <div class="owl-carousel">
        <div
          v-for="(slide, idx) in caterSlides"
          :key="idx"
          class="flex flex-col gap-5 items-center lg:p-10 p-7 sm:rounded-19 rounded-xl purple-orange-gradient justify-center"
        >
          <img
            :src="slide.imgSrc"
            :alt="slide.altText"
            class="w-full rounded-19 h-[302px] md:block hidden"
          />
          <h3 class="text-center leading-[47px] text-primary-gray-800 font-semibold">
            {{ slide.title }}
          </h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'owl.carousel'
import Icon from '@src/components/icons/icon.vue'
import { CATER_SLIDES } from '@src/constants/cater-to-constants.js'
export default {
  components: {
    Icon,
  },
  data() {
    return {
      landingPage: 'landingPage',
      prevSlideClicked: false,
      nextSlideClicked: true,
      caterSlides: CATER_SLIDES,
    }
  },
  computed: {
    iconLeftBorder() {
      return this.prevSlideClicked ? 'border-primary-purple-600' : 'border-primary-purple-300'
    },
    iconLeftColor() {
      return this.prevSlideClicked ? 'primary-purple-600' : 'primary-purple-400'
    },
    iconRightBorder() {
      return this.nextSlideClicked ? 'border-primary-purple-600' : 'border-primary-purple-300'
    },
    iconRightColor() {
      return this.nextSlideClicked ? 'primary-purple-600' : 'primary-purple-400'
    },
  },
  mounted() {
    this.initOwlCarousel()
  },
  beforeUnmount() {
    this.destroyOwlCarousel()
  },
  methods: {
    initOwlCarousel() {
      const options = {
        autoplay: false,
        loop: true,
        margin: 30,
        responsive: {
          0: {
            items: 1,
          },
          425: {
            items: 1.25,
          },
          768: {
            items: 2.25,
            margin: 20,
          },
          1024: {
            items: 2.5,
          },
          1160: {
            items: 2.955,
          },
          2000: {
            items: 3.4,
          },
          2500: {
            items: 3.9,
          },
        },
      }
      $(this.$el.querySelector('.owl-carousel')).owlCarousel(options)
    },
    prevSlide() {
      this.prevSlideClicked = true
      this.nextSlideClicked = false
      $(this.$el.querySelector('.owl-carousel')).trigger('prev.owl.carousel')
    },
    nextSlide() {
      this.prevSlideClicked = false
      this.nextSlideClicked = true
      $(this.$el.querySelector('.owl-carousel')).trigger('next.owl.carousel')
    },
    destroyOwlCarousel() {
      $('.owl-carousel').trigger('destroy.owl.carousel').removeClass('owl-loaded')
    },
  },
}
</script>

<style scoped>
.purple-orange-gradient {
  background: linear-gradient(
    213.03deg,
    #f4ebff 14.97%,
    #f4ebff 33.96%,
    #f4ebff 72.78%,
    #fce7f6 90.42%
  );
}
</style>
